module.exports = __webpack_public_path__ + "TruenoRg.7aba95e5ff98d5a275ce.otf";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/PROD-mufit-web/src/assets/fonts/TruenoRg.otf
// module id = ../../../../../src/assets/fonts/TruenoRg.otf
// module chunks = styles